import Vue from 'vue';
import router from './router';
import App from './App.vue';
import Vant from 'vant';
import moment from 'moment';
import './styles/main.css';
import './styles/iconfont.css';
import lang from './lang/lang.js';
import VueI18n from 'vue-i18n';
import 'vue-multiselect/dist/vue-multiselect.min.css';
import './styles/common.scss';
import 'vant/lib/index.css';
import common from "./common/common.js";
//import ElementUI from 'element-ui';
//import locale from 'element-ui/lib/locale/lang/en';
import 'element-ui/lib/theme-chalk/index.css';
import './styles/element-variables.scss';

import { Toast } from 'vant';
import { Lazyload } from 'vant';

//Vue.use(ElementUI, { locale })
Vue.use(VueI18n);
Vue.use(Vant);
Vue.use(Toast);
Vue.use(Lazyload);
Vue.prototype.$moment = moment;
// Vue.prototype._active = 0;
Vue.prototype.$bus = new Vue();

common.resetTabs();

const i18n = new VueI18n({
    locale: 'cn', // set locale
    messages: lang, // set locale messages
})

new Vue({
    el: '#app',
    router,
    i18n,
    render: h => h(App)
});



// WEBPACK FOOTER //
// ./src/main.js